import styled from 'styled-components';

export const ContentContainer = styled.div`
  padding: 0 6em;
  margin: 16px 0;
  @media (max-width: 720px) {
    padding: 0 1em;
  }
`;

export const OvulationHeading = styled.h2`
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 80%);
  font-size: clamp(16px, 3vw, 22px);
  padding-bottom: ${(props) => (props.padding ? '16px' : '0')};
`;

export const OvulationImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 48%);
  justify-content: space-between;

  img {
    width: 100%;
    height: auto;
    max-width: 360px;
    margin: 20px 0;
  }

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    margin: 20px auto;
    max-width: 320px;
  }
`;

export const OvulationPara = styled.p`
  margin: 20px 0;
  color: hsl(0deg, 0%, 0%, 80%);
  line-height: 1.45;
`;

export const ListedBelowSection = styled.div`
  padding: 0 16px;
`;

export const ListedBelow = styled.p`
  padding-top: 14px;
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const PurpleListSection = styled.div`
  background-color: hsl(338deg 100% 96% / 60%);
  padding: 30px 0;
  margin: 36px 0;
  border-radius: 4px;

  ul {
    padding: 0 30px;
    border-left: 6px solid #7b2382;
    list-style: disc;

    li {
      h4 {
        font-weight: 600;
        color: hsl(0deg, 0%, 0%, 80%);
        padding: 0 0 8px;
      }

      p {
        color: hsl(0deg, 0%, 0%, 87%);
      }

      padding: 10px 0;
    }
  }
`;
